/**
 * Clustering stays active at every practical zoom level. Items without their
 * own coordinates fall back to their site's, so many share the exact same
 * position — letting the clusterer stop early would render them as a stack of
 * overlapping pins where only the topmost one is clickable. Keeping them
 * clustered means they can be spiderfied instead.
 */
export const CLUSTER_MAX_ZOOM = 20;

export const CLUSTER_RADIUS_PX = 60;

/**
 * A cluster whose points span less than this (in degrees, ~11 m) is treated as
 * fully overlapping: zooming in would never separate it, so it spiderfies.
 */
export const COINCIDENT_SPAN_DEGREES = 1e-4;

/** Up to this many pins fan out onto a circle; beyond it, onto a spiral. */
export const SPIDERFY_CIRCLE_LIMIT = 9;

// Fanned-out pins must clear each other, so these separations are kept wider
// than MARKER_ICON_SIZE — shrinking the pin without shrinking these leaves
// wasted space, growing it without them makes the pins overlap.
export const SPIDERFY_CIRCLE_FOOT_SEPARATION = 38;
export const SPIDERFY_SPIRAL_FOOT_SEPARATION = 40;
export const SPIDERFY_SPIRAL_LENGTH_START = 22;
export const SPIDERFY_SPIRAL_LENGTH_FACTOR = 4;

export const MARKER_ICON_SIZE = 32;

/** Cluster bubbles grow with their count, capped so they never swallow the map. */
export const CLUSTER_ICON_MIN_SIZE = 40;
export const CLUSTER_ICON_MAX_SIZE = 64;
